
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/data-apps/sales-forecasting",
      function () {
        return require("private-next-pages/data-apps/sales-forecasting/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/data-apps/sales-forecasting"])
      });
    }
  